// RELEASE-TENIS10 § 11 P103 (Tudor, 2026-10-27, canvas B) — a tenis10.ro id as the CP shows it, „T10#33245”, and the help line
// under a plain number: the number searched the Sportya numbers only, and a tenis10.ro id is searched with its prefix — one
// click away.
import React from "react"
import { legacyIdText, plainNumberSearched } from "./claimsLabels"

/** A tenis10.ro id, `T10#33245` (`children` in place of the text: the Users list marks what the search found in it). */
export default function LegacyId({ id, children }) {
  const text = legacyIdText(id)
  return text ? <span className="text-nowrap">{children || text}</span> : null
}

/** Under a plain number (`33245`): it searched the Sportya numbers; the tenis10.ro id is searched as `T10#33245`. */
export function LegacySearchTip({ search, onSearch, className = "" }) {
  const number = plainNumberSearched(search)
  if (number === null) return null
  const legacy = legacyIdText(number)
  return <div className={`text-muted font-size-12 ${className}`} role="note">
    <i className="bx bx-info-circle mr-1" aria-hidden="true" />A plain number finds Sportya accounts and children's numbers. Looking
    for the tenis10.ro id {number}?{" "}
    <button type="button" className="btn btn-link btn-sm p-0 align-baseline font-size-12" onClick={() => onSearch(legacy)}>Search {legacy}</button>
  </div>
}
